
import classnames from "classnames";
import React from "react";
import { Icon, Icomoon } from "../..";

import "./IconButton.scss";

type HtmlProps = Pick<React.HTMLProps<HTMLButtonElement>, "disabled" | "className" | "children" | "onClick" | "title">;

interface Props extends HtmlProps {
  icomoon: string;
}

/**
 * A button to contain an icon.
 * 
 * @status stable
 */
export const IconButton = ({ icomoon: icon, className, children, ...htmlProps }: Props) => (
  <button type="button" className={classnames("icon-button", className)} {...htmlProps}>
    <Icon icomoon={icon as Icomoon} />
    {children}
  </button>
);
